<script setup>
const props = defineProps({
  propertyTypeObj: {
    type: Object,
    required: true,
  },
  mapConfig: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  markerList: {
    type: Array,
    required: false,
    default: () => [],
  },
  applyClusters: {
    type: Boolean,
    required: false,
    default: true,
  },
  autoFitBounds: {
    type: Boolean,
    required: false,
    default: true,
  },
  mapViewVisible: {
    type: Boolean,
    default: true,
  },
});

const testingStore = useTestingStore();
const isMapTilerEnabled = computed(() => testingStore.hasEnabledFeature('web_enableMapTiler'));

const HwMapMaptiler = defineAsyncComponent(() => import('@/components/common/HwMapMaptiler/index.vue'));
const HwMapbox = defineAsyncComponent(() => import('@/components/common/HwMapbox/index.vue'));

const mapImplementation = computed(() => (isMapTilerEnabled.value ? HwMapMaptiler : HwMapbox));
</script>

<template>
  <ClientOnly>
    <component
      :is="mapImplementation"
      v-bind="props"
    >
      <slot />
    </component>
    <template #fallback>
      <div class="map-container map-container-placeholder">
        <div class="map-canvas" />
      </div>
    </template>
  </ClientOnly>
</template>

<style lang="scss" scoped>
.map-container-placeholder {
  position: relative;
  height: 100%;
  width: 100%;
  min-height: wds-rem(200px);
  background-color: $wds-color-ink-lightest;

  .map-canvas {
    width: 100%;
    height: 100%;
  }
}

:deep(.map-container) {
  height: 100%;
  width: 100%;
}
</style>
